import { Text, Stack, List, InputBase, Flex, Center } from '@mantine/core';
import { useState } from 'react';
import QRCode from 'react-qr-code';
import { useUserData } from 'hooks/api/useUser';
import { useTranslation } from 'react-i18next';
import { removeWhiteSpace, sanitizeSecret } from 'utils/helpers';
import { IMaskInput } from 'react-imask';
import { isProduction } from 'utils/app';
import classes from 'global.module.css';

interface TwoStepAuthEnableListProps {
  isLoading: boolean;
  qrSecret: string;
  verifyCode: (sixDigitCode: string) => void;
}

export const TwoStepAuthEnableList = ({ qrSecret, isLoading, verifyCode }: TwoStepAuthEnableListProps) => {
  const { t } = useTranslation();
  const { data: userData } = useUserData();

  const [codeValue, setCodeValue] = useState('');
  const fibricheckName = isProduction ? 'FibriCheck' : 'FibriCheck@dev';

  const handleCodeChange = (value: string) => {
    setCodeValue(value);
    if (value.length === 7 && !isLoading) {
      verifyCode(removeWhiteSpace(value));
    }
  };

  return (
    <List>
      <List.Item>
        <Text>
          <Text fw={'bold'}>{t('mfa_enable_activation_step_one')}</Text>
          {t('mfa_enable_activation_step_one_description')}
        </Text>
      </List.Item>
      <List.Item>
        <Text>
          <Text fw={'bold'}>{t('mfa_enable_activation_step_two')}</Text>
          {t('mfa_enable_activation_step_two_description')}
        </Text>
        <Center mt={'md'}>
          <Text fw={'bold'}>{qrSecret}</Text>
        </Center>
        <Flex justify={'center'} my={'lg'}>
          <QRCode
            size={128}
            value={`otpauth://totp/${fibricheckName}:${userData?.user.email}?secret=${sanitizeSecret(qrSecret)}&issuer=${fibricheckName}`}
            viewBox={`0 0 128 128`}
          />
        </Flex>
      </List.Item>
      <List.Item>
        <Stack>
          <Text>
            <Text fw={'bold'}>{t('mfa_enable_activation_step_three')}</Text>
            {t('mfa_enable_activation_step_three_description')}
          </Text>
          <InputBase
            classNames={{ input: classes.inputCode }}
            w={180}
            value={codeValue}
            component={IMaskInput}
            mask={'000 000'}
            onKeyUp={(event: { currentTarget: { value: string } }) => handleCodeChange(event.currentTarget.value)}
            disabled={isLoading}
          />
        </Stack>
      </List.Item>
    </List>
  );
};
